class PolicyBank {
    constructor(id, value) {
        this.id = id
        this.value = value
    }

    static fromJson({ id, name }) {
        return new PolicyBank(id, name)
    }
}

export default PolicyBank
